"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFaqs = initFaqs;
const firebase_1 = require("./firebase");
const firestore_1 = require("firebase/firestore");
const chevron_down_svg_1 = __importDefault(require("./assets/icons/chevron-down.svg"));
const FIRESTORE_COLLECTION = "faqs";
function initFaqs(container) {
    container.innerHTML = `
      <div class="faqs">
        <div class="section-heading">Frequently Asked Questions</div>
        <div class="faq-list"></div>
      </div>
    `;
    const faqs = container.querySelector(".faqs");
    const sectionHeading = container.querySelector(".section-heading");
    const faqList = container.querySelector(".faq-list");
    if (!faqs || !sectionHeading || !faqList)
        return;
    loadFaqs(container);
    // const handleScroll = async () => {
    // const faqsRect = faqs.getBoundingClientRect();
    // const isInViewport = faqsRect.top <= 0 && faqsRect.bottom > 0;
    // if (isInViewport) {
    //     sectionHeading.classList.add("sticky");
    // } else {
    //     sectionHeading.classList.remove("sticky");
    // }
    // };
    // const throttle = (func: Function, limit: number) => {
    //     let lastCall = 0;
    //     return (...args: any[]) => {
    //         const now = Date.now();
    //         if (now - lastCall >= limit) {
    //             lastCall = now;
    //             func(...args);
    //         }
    //     };
    // };
    // window.addEventListener("scroll", throttle(handleScroll, 200));
}
function loadFaqs(container) {
    return __awaiter(this, void 0, void 0, function* () {
        const faqList = container.querySelector(".faq-list");
        if (!faqList)
            return;
        try {
            const db = yield (0, firebase_1.getFirestoreInstance)();
            let faqsQuery = (0, firestore_1.query)((0, firestore_1.collection)(db, FIRESTORE_COLLECTION), (0, firestore_1.orderBy)("question", "asc"));
            const querySnapshot = yield (0, firestore_1.getDocs)(faqsQuery);
            if (querySnapshot.empty) {
                console.log("No FAQs available");
                return;
            }
            querySnapshot.forEach((doc) => {
                var _a, _b;
                const faqData = doc.data();
                console.log("faqData - ", faqData);
                const faqElement = document.createElement("div");
                faqElement.classList.add("faq");
                faqElement.innerHTML = `
                <div class="content-wrapper">
                    <div class="question">${(_a = faqData.question) === null || _a === void 0 ? void 0 : _a.trim()}</div>
                    <div class="answer">${(_b = faqData.answer) === null || _b === void 0 ? void 0 : _b.trim()}</div>
                </div>
                <div class="expand-collapse-wrapper">
                    <img src="${chevron_down_svg_1.default}" alt="Expand/Collapse" />
                </div>
            `;
                faqList.appendChild(faqElement);
            });
            faqList.addEventListener("click", (event) => {
                const target = event.target;
                if (target.closest(".expand-collapse-wrapper")) {
                    const faqElement = target.closest(".faq");
                    if (faqElement.classList.contains("expand")) {
                        faqElement.classList.remove("expand");
                    }
                    else {
                        faqElement.classList.add("expand");
                    }
                }
            });
        }
        catch (error) {
            console.error("Error loading faqs:", error);
        }
    });
}
